module.exports = __webpack_public_path__ + "img/logo-g.0e5df152.svg";